// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21wI5","comment":"styles_comment__1gtnS"};